import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { name: 'Enter Site', path: '/home' },
    { name: 'The National Memorial Garden', path: '/masterplan' },
    { name: 'Our Services', path: '/services' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Investment', path: '/investment' }
  ];

  const handleScreenClick = () => {
    navigate('/home');
  };

  return (
    <div 
      className="min-h-screen relative overflow-hidden cursor-pointer" 
      onClick={handleScreenClick}
    >
      {/* Elegant Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-amber-900"></div>
        <div className="absolute inset-0 opacity-10">
          <div 
            className="w-full h-full bg-cover bg-center"
            style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1598161966801-4c8898ba6305?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxwZWFjZWZ1bCUyMGdhcmRlbnxlbnwwfHx8fDE3NTYxMjQzMDN8MA&ixlib=rb-4.1.0&q=85')",
              filter: 'blur(2px)'
            }}
          ></div>
        </div>
      </div>

      {/* Dropdown Menu in Top Corner */}
      <div className="absolute top-6 right-6 z-50" onClick={(e) => e.stopPropagation()}>
        <div className="relative">
          <Button
            variant="ghost"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 border border-white/30 px-4 py-2 rounded-xl shadow-xl"
          >
            Menu
            <ChevronDown 
              className={`ml-2 transition-transform duration-300 ${isMenuOpen ? 'rotate-180' : ''}`} 
              size={16} 
            />
          </Button>
          
          {/* Dropdown Menu */}
          {isMenuOpen && (
            <div className="absolute top-full right-0 mt-2 w-56 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/20 overflow-hidden">
              <div className="py-2">
                {menuItems.map((item, index) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`block px-6 py-3 text-gray-800 hover:bg-gradient-to-r hover:from-amber-50 hover:to-orange-50 transition-all duration-200 font-medium ${
                      index === 0 ? 'border-b border-gray-200' : ''
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Logo Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="text-center">
          {/* Logo Container */}
          <div className="mb-12">
            <div className="relative mx-auto w-96 h-96 md:w-[768px] md:h-[768px]">
              {/* Glow effect behind logo */}
              <div className="absolute inset-0 bg-gradient-to-r from-amber-400/20 to-orange-500/20 rounded-full filter blur-3xl animate-pulse"></div>
              
              {/* Logo */}
              <img 
                src="https://customer-assets.emergentagent.com/job_fenix-company/artifacts/i9muya6m_Fenix%20Logo.jpg"
                alt="The Fenix Partnership"
                className="relative z-10 w-full h-full object-contain drop-shadow-2xl"
              />
            </div>
          </div>

          {/* Single tagline */}
          <div>
            <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed">
              For Eternal Rest and Living Memory
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;